module.exports = __webpack_public_path__ + "static/media/novena_aguinaldo.af36dd91.svg";